/* Stay AI START */
(function() {
  window.addEventListener('DOMContentLoaded', function (){
    const purchaseTypes = document.querySelectorAll('input[name="mockPurchaseType"]');

    function updateCTAPrice(sel) {
      const priceEl = sel.parentElement.querySelector('[data-stayai-onetime-price], [data-stayai-subscription-price]');
      const atcButton = document.querySelector('form #btnAddTocart')
      const formPrice = document.querySelector('form #productPrice');
      
      if (!priceEl || !atcButton || !formPrice) return
      atcButton.removeAttribute('data-price-mutation-watcher')
      const priceChildNodes = priceEl.childNodes;
      const priceText = Array(...priceChildNodes).find((node) => node.nodeName.includes('text'))
      
      if (!priceText || priceText === '') return
      formPrice.innerText = priceText.textContent || formPrice.innerText
    }

    function setStayOptions(el) {
      if (!el) return
      const normalizedType = el.value.toLowerCase();
      const stayWidget = document.querySelector('.stayai-widget')

      if ((normalizedType !== 'onetime' && normalizedType !== 'subscription') || !stayWidget) return;

      const stayOneTime = stayWidget.querySelector('#purchaseTypeOneTime')
      const staySubscription = stayWidget.querySelector('#purchaseTypeSubscription');
      const selectedOption = normalizedType === 'onetime' ? stayOneTime : staySubscription;

      selectedOption.click();
      updateCTAPrice(selectedOption)
    }

    purchaseTypes.forEach((option) => {
      option.addEventListener('change', (e) => {
        setStayOptions(e.target)
      })
    }) 
  });
  
})()
/* Stay AI END */